<form [formGroup]="lieuImmobilisationForm" (ngSubmit)="addLieuImmobilisation()">
  <div class="form-container">
    <div>
      <label>{{'referentiels.list.lieuImmobilisationProperties.raison.header' | transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="lieu" />
      <small class="p-error block">
        @if (lieuImmobilisationForm.controls.lieu.errors?.required) {
          <p-message *ngIf="lieuImmobilisationForm.controls['lieu'].invalid && lieuImmobilisationForm.controls['lieu'].touched" severity="danger" text="Le lieu est requis."></p-message>
        } @else if (lieuImmobilisationForm.controls.lieu.errors?.maxlength) {
          <p-message *ngIf="lieuImmobilisationForm.controls['lieu'].invalid && lieuImmobilisationForm.controls['lieu'].touched" severity="danger" text="Le lieu ne doit pas dépasser 150 caractères."></p-message>
        }
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button [rounded]="true" pRipple label="{{ 'button.cancel' | transloco }}" (onClick)="close(false)" />
    <p-button [rounded]="true" type="submit" [disabled]="lieuImmobilisationForm.invalid" pRipple label="{{ 'button.validate' | transloco }}" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
